import BaseStore from 'bz-stores/mobx/base-store';
import { action } from 'mobx';
import type { AuthenticateResponse } from 'tm3-core/api.dtos';
import { ChangePasswordRequest } from 'tm3-core/api.dtos';

class ChangePasswordFormStore extends BaseStore<any> {
  @action.bound
  async handleSavePassword(values: ChangePasswordRequest): Promise<AuthenticateResponse> {
    const req: ChangePasswordRequest = new ChangePasswordRequest(values);
    return await this.client.post(req);
  }
}

export default ChangePasswordFormStore;
